export enum BuyGiftCardStateEnum {
    CHOOSE_CARD_DETAILS ="CHOOSE_CARD_DETAILS",
    CHOOSE_RECIPIENTS = "CHOOSE_RECIPIENTS",
    CHOOSE_SENDER = "CHOOSE_SENDER",

    CUSTOMISE_CARD = "CUSTOMISE_CARD",
    CUSTOMISE_MAIL = "CUSTOMISE_MAIL",

    REVIEW_PAY_REVIEW = "REVIEW_PAY_REVIEW",    
    REVIEW_PAY_SENDER_INFO = "REVIEW_PAY_SENDER_INFO",    
    REVIEW_PAY_WHEN_TO_SEND = "REVIEW_PAY_WHEN_TO_SEND",    
    REVIEW_PAY_PAYMENT = "REVIEW_PAY_PAYMENT",    
}